/**
 * Available distress signal field names
 * Must match functions/utils/distressSignals.js DISTRESS_FIELD_NAMES
 */
export const DISTRESS_FIELD_NAMES = [
    'preForeclosure',
    'death',
    'deathTransfer',
    'spousalDeath',
    'inherited',
    'auction',
    'bankOwned',
    'deedInLieu',
    'trusteeSale',
    'sheriffsDeed',
    'judgment',
    'lien',
    'taxLien',
    'quitClaim',
    'vacant',
    'cashSale',
    'cashBuyer',
    'freeClear',
    'absenteeOwner',
    'corporateOwned',
    'foreclosureInfo',
    'noticeType'
];

/**
 * Format distress signal field name to readable label
 */
export const formatDistressLabel = (field) => {
    return field.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()).trim();
};
